import Footer from "../Footer";
import Header from "../Header";
import PermissionTable from "./PermissionTable";

export default function UserFLowTable() {
  return (
    <>
    <Header/>
      <div className="min-h-screen bg-gray-50 p-4 md:p-8">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-2xl md:text-3xl font-bold text-blue-800 mb-6">
            Salus Scaffold - User Access Management
          </h1>
          <PermissionTable />
        </div>
      </div>
      <Footer/>
    </>
  );
}
